@let meetingsData = meetings();
@let isEditMode = service.isEditMode();

<div class="d-flex justify-content-between">
	@if(userType(); as userType){
	<div class="mb-3"> {{userType}}'s TimeZone : <strong>{{applicantTimeZone()}}</strong></div>
	}

	<p>Number of Meetings: <b>{{service.updatedSelectedSlots()?.numMeetings ?? meetingsData.numMeetings}}</b></p>
	<p>Last Updated: <b>{{lastUpdatedDate()}}</b></p>

</div>

<div class="d-flex justify-content-between align-items-center">
	<div class="row col-5">
		<common-select-field [field]="timeZoneIdField()"></common-select-field>
	</div>
	@if(canEdit() && !isEditMode){
	<common-button-row [center]="true" class="align-items-start">
		<button class="btn btn-standard" (click)="service.setIsEditMode(true)">Edit Schedule</button>
	</common-button-row>
	}
</div>

<schedule-table-part [meetingsId]="meetingsData?.meetingsId" [blockoutSlots]="blockoutSlots()" [selectedSlots]="meetingsData?.selectedMeetingSlots"
	[timeZoneId]="selectedTimeZoneId()" [minimumSelectionSlots]="minimumSelectionSlots()" (saved)="saved.emit()">
</schedule-table-part>